<script lang="ts">
  import IconButton from "app/components/+design-system/IconButton/IconButton.svelte";
  import TabTitle from "./TabTitle.svelte";
  import cx from "classnames";
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";
  import { tabBlocks } from "app/components/editor/extensions/blocks/Tabs/tabs";
  import { Trash } from "$components/+shared/OVIcon";

  export let isEditable: boolean;
  export let title: string;
  export let blockId: string;
  export let tabId: string;

  let element: HTMLDivElement;
  let isActive = false;

  const dispatch = createEventDispatcher();

  $: isActive = $tabBlocks.get(blockId)?.activeTab === tabId;
</script>

<!-- if in edit mode and the tab is active, calculate the width of the title input and add additional width to accomodate for the delete button -->
<!-- otherwise, the width is the width of the input -->
<!-- this transition is animated through transition-[width] -->
<div
  style={isEditable && isActive
    ? `width: calc(${element?.clientWidth}px + 28px); padding-right: 28px`
    : `width: calc(${element?.clientWidth}px)`}
  class={cx(
    "relative flex min-w-fit shrink-0 items-center whitespace-nowrap border-b transition-[width,padding,border] duration-300 ease-out",
    {
      "border-community-primary ": isActive,
      "border-transparent ": !isActive,
    }
  )}
  role="tab"
  aria-selected={isActive}
  contenteditable="false"
>
  <div class="flex items-center" bind:this={element}>
    {#if isEditable && isActive}
      <!-- editable title -->
      <TabTitle
        value={title}
        on:update={(event) => {
          dispatch("update-title", event.detail);
        }}
      />

      <!-- delete tab button -->
      <div
        in:fade={{ delay: 100, duration: 150 }}
        class="absolute right-0 flex h-full items-center px-1"
      >
        <IconButton
          icon={Trash}
          variant="tertiary"
          a11yLabel="Delete tab"
          on:click={() => dispatch("delete-tab")}
        />
      </div>
    {:else}
      <!-- tab button -->
      <button
        type="button"
        on:click={() => dispatch("switch-tab")}
        class={cx(
          "ov-focus mx-1 my-2 flex min-w-fit whitespace-nowrap rounded-md px-2 py-1 transition-colors duration-300 after:rounded-md",
          {
            "text-gray-500 dark:text-white/95": isActive,
            "text-gray-400 hover:bg-gray-400/10 hover:text-gray-500 dark:text-gray-500 dark:hover:bg-white/5 dark:hover:text-gray-300":
              !isActive,
          }
        )}
      >
        {title}
      </button>
    {/if}
  </div>
</div>
